module.exports = __webpack_public_path__ + "img/login.9ae20e99.jpg";